export default __webpack_public_path__ + "static/media/hploop.3614437b.mp4";